import { GetApplyQuickFilterFn } from "@mui/x-data-grid";

const QuickFilter: GetApplyQuickFilterFn<any, unknown> = (value) => {
  if (!value) {
    return null;
  }

  return (cellValue) => {
    if (!cellValue) {
      return false;
    }

    // handle columns where we have to use a compound value in valueGetter
    if (typeof cellValue === "object") {
      const results = Object.values(cellValue).filter(
        (cv) => cv && cv.toString().toLowerCase().includes(value.toLowerCase())
      );

      return results.length > 0;
    } else {
      return cellValue
        ? cellValue.toString().toLowerCase().includes(value.toLowerCase())
        : false;
    }
  };
};

export default QuickFilter;
